import GalleryOneWeb from "../assets/images/webps/gallery_1.webp";
import GalleryOne from "../assets/images/others/gallery_1.jpg";
import GalleryTwoWeb from "../assets/images/webps/gallery_2.webp";
import GalleryTwo from "../assets/images/others/gallery_2.jpg";
import GalleryThreeWeb from "../assets/images/webps/gallery_3.webp";
import GalleryThree from "../assets/images/others/gallery_3.jpg";
import GalleryFourWeb from "../assets/images/webps/gallery_4.webp";
import GalleryFour from "../assets/images/others/gallery_4.jpg";
import GalleryFiveWeb from "../assets/images/webps/gallery_5.webp";
import GalleryFive from "../assets/images/others/gallery_5.jpg";
import GallerySixWeb from "../assets/images/webps/gallery_6.webp";
import GallerySix from "../assets/images/others/gallery_6.jpg";


export const GalleryData = [
    {
        name: 'Oficial Dinners',
        imgWeb: GalleryOneWeb,
        imgNorm: GalleryOne
    },
    {
        name: 'Backyard Parites',
        imgWeb: GalleryTwoWeb,
        imgNorm: GalleryTwo
    },
    {
        name: 'Coorporate Events',
        imgWeb: GalleryThreeWeb,
        imgNorm: GalleryThree
    },
    {
        name: 'Wedding Events',
        imgWeb: GalleryFourWeb,
        imgNorm: GalleryFour
    },
    {
        name: 'Annivery Events',
        imgWeb: GalleryFiveWeb,
        imgNorm: GalleryFive
    },
    {
        name: 'Fairwell Parites',
        imgWeb: GallerySixWeb,
        imgNorm: GallerySix
    }
]